// extracted by mini-css-extract-plugin
export default {"hyperlink":"Hyperlink_hyperlink__8rah2"};